import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'
import { setSearchSession } from 'actions/SearchActions'
import uuidV4 from 'lib/string/uuidV4Utils'

export default function useSearchSession(searchKey: string): App.SearchSession {
  const dispatch = useAppDispatch()

  const existingSearchSession = useAppSelector(state => state.search.searchSessions[searchKey])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const newSessionId = useMemo(() => uuidV4(), [searchKey])

  useEffect(() => {
    if (!existingSearchSession) {
      dispatch(setSearchSession(searchKey, { searchSessionId: newSessionId }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey])

  const newSearchSession = useMemo(() => ({ searchSessionId: newSessionId }), [newSessionId])

  return existingSearchSession ?? newSearchSession
}
